import {
  IAllContractShifts,
  ICounterShiftContract,
  ILongTermContractModel,
  pharmacistEvent,
  professionalCompleteContract,
  WorkshiftStatus,
} from '@pharmaplan/common';
import { useMemo } from 'react';
import { useAppSelector } from '../useAppSelector';
import useGetItems from '../useGetItems';
import { CancelContractType } from '../../helpers/Constants';

const { professionalDashboard, professionalReport } = CancelContractType;

interface IEvent {
  shifts?: Array<IAllContractShifts>;
  longTermShiftContract?: ILongTermContractModel;
  counterShiftContract?: ICounterShiftContract;
  favorite?: boolean;
  logoImage: string;
  pharmacyName: string;
  startDate: string;
  softwareName: string;
}

const useCancelContractRequestModal = (
  eventType: CancelContractType,
  longTermContractId?: string,
) => {
  const event = useAppSelector(professionalCompleteContract);
  const dashboardEvent = useAppSelector(pharmacistEvent);

  const { getImage } = useGetItems();

  const {
    weekDayPaidHourlyRate,
    weekendPaidHourlyRate,
    allowanceNotes,
    contractEndDate,
    contractStartDate,
    name,
    logoId,
    softwareName,
  } = event ?? {};

  const eventData = useMemo(
    () =>
      event?.data.map((item) =>
        ({
          ...item,
          status: WorkshiftStatus.Requested,
        })),
    [event.data],
  );

  const reportEvent: IEvent = {
    ...event,
    softwareName,
    startDate: contractStartDate,
    shifts: eventData,
    logoImage: getImage(logoId),
    pharmacyName: name,
    longTermShiftContract: {
      longTermShiftContractId: longTermContractId ?? '',
      weekDayPaidHourlyRate,
      weekendPaidHourlyRate,
      allowanceNotes,
      startDate: contractStartDate,
      endDate: contractEndDate,
    },
  };

  const eventConfig = {
    [professionalDashboard]: dashboardEvent,
    [professionalReport]: reportEvent,
  };

  return eventConfig[eventType];
};

export default useCancelContractRequestModal;
